import styled from 'styled-components';
import {DARK_GRAY} from '../../../globalVariables/GlobalVariables';
import * as imagePopupCss from '../ImagePopup.css';
import {popUpBody} from '../../newPopup/smallPopUp/SmallPopUp.css';

export const image = styled(imagePopupCss.image)`
    margin: auto;
`;

export const wrapPopup = styled(imagePopupCss.wrapPopup)`
    position: relative;
    inset: 0;
    height: 100%;
    div, input{
        color: ${DARK_GRAY} !important;
    }
    ${popUpBody}{
        left: auto;
        top: 50%;
        transform: translateY(-50%);
        inset-inline-start: clamp(10px, calc(50% - 180px), calc(100vw - 10px));
    }
`;

export const wrapAll = styled(imagePopupCss.wrapAll)``;
export const top = styled(imagePopupCss.top)``;
export const buttons = styled(imagePopupCss.buttons)``;
export const details = styled(imagePopupCss.details)``;